<template>
  <div>
    <div class="row">
      <div class="col-6 d-flex flex-column align-items-center">
        <div class="input-wrapper">
          <label>Ethnicity</label>
          <el-select
              v-model="localFilters.demographics.ethnicity.value" collapse-tags
              placeholder="Select values" @change="updateDropdownValues(localFilters)"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getDemographicsTagValues('ethnicity')"
                  :key="value" :label="value" :value="value">
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Gender</label>
          <el-select
              v-model="localFilters.demographics.gender.value" @change="updateDropdownValues(localFilters)"
              placeholder="Select values" collapse-tags
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getDemographicsTagValues('gender')"
                  :key="value" :label="value" :value="value">
              </el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>
      <div class="col-6 d-flex flex-column align-items-center">
        <div class="input-wrapper" style="padding-bottom: 17px">
          <label>Age</label>
          <div class="slider-wrapper">
            <vue-slider
              v-if="Object.keys(ageInput).length"
              :model-value="ageInput.value"
              range
              lazy
              :data="ageBins"
              :marks="true"
              adsorb
              :process="ageSliderProcess"
              tooltip="none"
              included
              @update:model-value="setAgeHandles"
              @change="parseAge"
            >
            </vue-slider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import ageRange from '../../../helpers/ageRange'
export default {
  name: 'DemographicsForm',
  emits: ['update:filters'],
  components: {
    VueSlider
  },
  props: {
    filters: Object,
    getDemographicsTagValues: Function,
    updateDropdownValues: Function
  },
  data () {
    return {
      localFilters: _.cloneDeep(this.filters),
      ageInput: {
        value: ageRange.sliderFromFilters(
          this.filters.demographics.startAge.value,
          this.filters.demographics.endAge.value
        ),
        includeMissing: true
      },
      ageBins: ageRange.AGE_BINS,
      ageSliderProcess: dotsPos => [
        [dotsPos[0], dotsPos[1], {
          backgroundColor: '#962292',
          height: '6px',
          transform: 'translate(0px, -1px)'
        }]
      ],
      socialClassInputValue: ''
    }
  },
  methods: {
    // The only place the handles are written. Dragging one handle past the other
    // makes the slider emit the pair in dot order, so keep it ascending here.
    setAgeHandles (value) {
      const handles = ageRange.sortedHandles(value)
      if (handles) this.ageInput.value = handles
    },
    // With `lazy` the slider reports only on release, so this runs once per
    // gesture and the stored range is never rewritten mid-drag.
    parseAge (value) {
      const { startAge, endAge } = ageRange.filtersFromSlider(value)
      this.localFilters.demographics.startAge.value = startAge
      this.localFilters.demographics.endAge.value = endAge
    },
    // Put the handles where the stored range is, and store only band-edge
    // values so the tag and the query describe the same range as the handles.
    syncAgeSlider () {
      const { startAge, endAge } = this.localFilters.demographics
      const next = ageRange.normalizeFilters(startAge.value, endAge.value)
      if (next.startAge !== startAge.value || next.endAge !== endAge.value) {
        startAge.value = next.startAge
        endAge.value = next.endAge
      }
      const handles = ageRange.sliderFromFilters(next.startAge, next.endAge)
      if (!_.isEqual(handles, this.ageInput.value)) {
        this.ageInput.value = handles
      }
    },
    clearAgeInput () {
      this.$set(this.ageInput, 'value', [...ageRange.sliderFromFilters('', '')])
      this.localFilters.demographics.startAge.value = ''
      this.localFilters.demographics.endAge.value = ''
    },
    clearSocialClass () {
      this.socialClassInputValue = ''
    },
    setSocialClass (data) {
      this.socialClassInputValue = data
    }
  },
  mounted () {
    this.syncAgeSlider()
    // console.log(this.filters)
    // if (this.filters.demographics.socialClass.value) {
    //   this.socialClassInputValue = this.getDemographicsTagValues('social_class').find(el => el.value === this.filters.demographics.socialClass.value).label
    // }
  },
  watch: {
    filters: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.localFilters)) {
          this.localFilters = _.cloneDeep(value)
        }
        // A saved search or a removed tag changes the filters from outside.
        this.syncAgeSlider()
      }
    },
    localFilters: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.filters)) {
          this.$emit('update:filters', _.cloneDeep(value))
        }
      }
    },
    socialClassInputValue (newData) {
      if (newData) {
        const test = this.getDemographicsTagValues('social_class').find(el => el.label === newData).value
        this.$set(this.localFilters.demographics.socialClass, 'value', test)
      } else {
        this.$set(this.localFilters.demographics.socialClass, 'value', '')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variables";

.input-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.input-wrapper input {
  width: 100%;
}

.input-wrapper .el-select {
  width: 100%;
}

.input-wrapper label {
  color: $input-label;
  margin-bottom: 2px;
  margin-left: 2px;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 13px;
  line-height: 20px;
  font-weight: 600;
}

.slider-wrapper {
  width: 92%;
  margin: 2px auto 0;
}
</style>
